import React from 'react';
import {Button} from "react-materialize";
import {dateFormatter} from "../../../Utilities/utilities";

const TransactionsList = ({transactions, handleTransactionSelect, loading}) => {
  const handleClick = (transaction) => {
    handleTransactionSelect(transaction);
  }

  let noTransactionsMessage = loading ? 'Fetching Transactions...' : 'No transactions found';
  return (
    <tbody>
      {transactions.length > 0 && !loading ?
        transactions.map((transaction) => {
          const {date, type, sent, received, source, id, counterParty, transactionID} = transaction;
          return (
            <tr onClick={() => handleClick(transaction)}>
              <td>{dateFormatter(date)}</td>
              <td>{type}</td>
              <td>{sent.quantity} {sent.asset.code}</td>
              <td>{received.quantity} {received.asset.code}</td>
              <td>{source}</td>
              <td>{id}</td>
              <td>{counterParty}</td>
              <td><Button>Reconcile</Button></td>
            </tr>
          )
        })
        :
        <tr onClick={handleClick}>
          <td>{noTransactionsMessage}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      }
    </tbody>
  )
}

export default TransactionsList;